import { FC } from "react";
import { useMapState } from "../Map/v2/GoogleMap/MapStateContext";
import { TopRightSection } from "../Map/Map.styled";
import MapRightTop from "../Map/v1/children/MapRightTop";

interface Props {
  showEnableDisableClustersButton?: boolean;
}

const DashboardMapTopRightSection: FC<Props> = ({
  showEnableDisableClustersButton = true
}) => {
  const {
    objectsMarker,
    isDashboardMap,
    isObjectDetailsPage,
    showSatelliteMode,
    setShowSatelliteMode,
    showClusters,
    showTraffic,
    setShowTraffic,
    showObjectNames,
    setShowObjectNames,
    showGeozones,
    setShowGeozones,
    autoFitVisibleUnits,
    handleEnableClusterClick,
    handleShowGeozoneClick,
    handleAutoFitVisibleUnitsButtonClick
  } = useMapState();

  return (
    <>
      <TopRightSection />
      <MapRightTop
        showSatelliteMode={showSatelliteMode}
        setShowSatelliteMode={setShowSatelliteMode}
        showClusters={showClusters}
        showTraffic={showTraffic}
        setShowTraffic={setShowTraffic}
        handleClusterClick={handleEnableClusterClick}
        showObjectNames={showObjectNames}
        setShowObjectNames={setShowObjectNames}
        objectsMarker={objectsMarker}
        showGeozones={showGeozones}
        setShowGeozones={setShowGeozones}
        handleShowGeozoneClick={handleShowGeozoneClick}
        isDashboardMap={isDashboardMap}
        showEnableDisableClustersButton={showEnableDisableClustersButton}
        showFitToVisibleUnitsButton={isDashboardMap && !isObjectDetailsPage}
        autoFitVisibleUnits={autoFitVisibleUnits}
        onAutoFitVisibleUnitsButtonClick={handleAutoFitVisibleUnitsButtonClick}
      />
    </>
  );
};

export default DashboardMapTopRightSection;
